import React from 'react';
import type { Candidate } from '@axiom/validation';

import { Well } from '../../layout/Well/Well';
import { Gutter } from '../../layout/Gutter/Gutter';
import { SectionHeader } from '../../content/SectionHeader/SectionHeader';
import { Paragraph } from '../../content/Paragraph/Paragraph';
import { ReadonlyTextarea } from '../../form/Textarea/ReadonlyTextarea';

export type CandidateDescriptionTypes = {
  description: string;
  calculatedFirstName: Candidate['calculatedFirstName'];
  formatting?: 'legacy' | 'modern';
};

export const CandidateDescription = ({
  description,
  calculatedFirstName,
  formatting = 'legacy',
}: CandidateDescriptionTypes) => {
  return (
    <Well name="CANDIDATE_DESCRIPTION" background="light blue">
      <Gutter bottom="8px">
        <SectionHeader name="FIRST_NAME">
          About {calculatedFirstName}
        </SectionHeader>
      </Gutter>
      <Paragraph name="DESCRIPTION">
        <ReadonlyTextarea value={description} formatting={formatting} />
      </Paragraph>
    </Well>
  );
};
